import { defineStore } from "pinia";

import { GET_WAREHOUSES_LIST } from "@/api/warehouses/index.js";
import { Warehouse } from "@/types/warehouse/warehouse.js";
import { apollo } from "@/utils/apollo.ts";

interface State {
  all: Warehouse[]
}

export const useWarehousesStore = defineStore("warehouses", {
  state: (): State => ({
    all: [],
  }),

  actions: {
    async fetchAllWarehouses() {
      try {
        const { data } = await apollo.query({
          query: GET_WAREHOUSES_LIST,
        });
        this.all = data.getAllWarehouses;
      }
      catch (error) {
        console.error(error);
      }
    },
  },
});
